export enum bodyClassName {
  overflowHidden = 'has-overflow-hidden',
  gutterBottom = 'has-gutter-bottom',
}
